import $ from 'jquery';
import * as lightbox from '../../../home24/helpers/lightbox';
import BaseView from '../../core/baseView';
import RemotePreloaderView from '../../validation/remotePreloaderView';
import { get as t } from '../../../home24/core/translation';
import * as config from '../../../home24/core/config';

export default BaseView.extend({
  events: {
    submit: 'onSubmit'
  },

  selectors: {
    ibanField: '.js-iban input',
    bicField: '.js-bic input'
  },

  validationRules: {
    remoteIban: {
      url: config.getBaseUrl() + '/default/validator/validateiban',
      type: 'GET',
      data: {
        iban: function() {
          return $('.js-iban input').val();
        }
      },
      beforeSend: function() {
        this.preloader =
          this.preloader ||
          new RemotePreloaderView({
            el: $(this).find('.js-iban input')
          });
        this.preloader.show();
      },
      complete: function() {
        this.preloader.hide();
      }
    },
    remoteBic: {
      url: config.getBaseUrl() + '/default/validator/validatebic',
      type: 'GET',
      data: {
        id: function() {
          return $('.js-bic input').val();
        }
      },
      beforeSend: function() {
        this.preloader =
          this.preloader ||
          new RemotePreloaderView({
            el: $(this).find('.js-bic input')
          });
        this.preloader.show();
      },
      complete: function() {
        this.preloader.hide();
      }
    }
  },

  initialize: function() {
    this.$ibanField = this.$el.find(this.selectors.ibanField);
    this.$bicField = this.$el.find(this.selectors.bicField);

    this.$bicField.rules('remove');

    this.addRulesToValidator(
      this.$ibanField,
      this.validationRules.remoteIban,
      t('ui.input.validation.iban.remote.error')
    );

    this.addRulesToValidator(
      this.$bicField,
      this.validationRules.remoteBic,
      t('ui.input.validation.bic.remote.error')
    );
  },

  onSubmit: function() {
    var _this = this;
    var result = false;

    if (this.isEmpty()) {
      lightbox
        .setConfig({
          $dialog: $('.js-fttc2-bank-details'),
          className: 'fttc2-bank-details'
        })
        .open();

      $('.js-fttc2-bank-details__proceed').one('click', function() {
        _this.$el[0].submit();
      });
    } else {
      result =
        this.$el.valid() && !this.$ibanField.prev().hasClass('is-invalidate');
    }

    return result;
  },

  isEmpty: function() {
    var isEmpty = true;
    var $fields = this.$el.find('input');

    $fields.each(function() {
      if (this.value.length) {
        isEmpty = false;
      }
    });

    return isEmpty;
  },

  addRulesToValidator: function($field, $remoteRule, message) {
    $field.rules('add', {
      remote: $remoteRule,
      messages: {
        remote: message
      }
    });
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc2/Step3Controller.js
 **/